/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const { Link } = require('frontend-spa');
const MenuUtils = require('../../../../utils/menu');
const { sanitizePath } = require('../../../common/URLSanitizer');
const InstorePaymentsImages = require('./images');
const { getEventTracker } = require('../../../../utils/event-tracker');

function InPersonPayments(props) {
  const Tracker = getEventTracker();
  const { i18n, lang, platform, deviceType, setActiveItem } = props;
  const { siteId } = platform;
  const showPoint = siteId.match(/^(MLA|MLB|MLM|MPE|MLC|MCO)$/);
  const { InPersonPaymentsQRCode, InPersonPaymentsPoint } = InstorePaymentsImages;

  return (
    <div className="instore-payments-container">
      <div className="instore-payments-title">
        <div className="instore-payments-title__text">
          <h1>{i18n.gettext('Acepta pagos en tu local')}</h1>
          <p>{deviceType === 'desktop'
            ? (`${i18n.gettext('Integra experiencias de pago en el mundo físico')}. ${i18n.gettext('Soluciones ideales para negocios que quieran procesar pagos rápidos y seguros desde donde sea')}.`)
            : ''}
          </p>
        </div>
      </div>

      <div className="instore-payments-main-cards">
        <Card className="instore-payments__card" animated>
          <Link
            to={`/developers/${lang}/guides/in-person-payments/qr-code/introduction`}
            onClick={() => {
              Tracker.send('mpdevelopers/click_ipp_landing_qr');
              setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/in-person-payments/qr-code/introduction`), platform.siteId.toLowerCase(), lang));
            }}
          >
            <CardContent className="card-content">
              <InPersonPaymentsQRCode />
              <h3>{i18n.gettext('Código QR')}</h3>
              <p>{i18n.gettext('Elige un modelo de integración para generar códigos QR y brinda una experiencia completa de pagos presenciales')}.</p>
            </CardContent>
          </Link>
        </Card>
        { showPoint && (
        <Card className="instore-payments__card" animated>
          <Link
            to={`/developers/${lang}/guides/in-person-payments/mp-point/introduction`}
            onClick={() => {
              Tracker.send('mpdevelopers/click_ipp_landing_point');
              setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/in-person-payments/mp-point/introduction`), platform.siteId.toLowerCase(), lang));
            }}
          >
            <CardContent className="card-content">
              <InPersonPaymentsPoint />
              <h3>{i18n.gettext('Mercado Pago Point')}</h3>
              <p>{i18n.gettext('Integra Mercado Pago Point y conecta el lector de tarjetas con cualquier sistema iOS o Android para aceptar cobros en puntos de venta')}.</p>
            </CardContent>
          </Link>
        </Card>
        )}
        { !showPoint && (
        <div className="instore-payments__card" />
        )}
        <div className="instore-payments__card" />
      </div>
    </div>
  );
}

InPersonPayments.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    siteId: PropTypes.string,
    domain: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
};

InPersonPayments.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = InPersonPayments;
